import React, { useState, forwardRef } from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';
import InputField from './InputField';

/**
 * Full-width outlined input + toggle — same DOM shape as a plain InputField (no flex sibling),
 * so MDB notch/label layout matches Add User / Edit User. Icon is overlaid inside padding (pe-5).
 */
const PasswordInput = forwardRef(({ id, name, label, value, onChange, className, wrapperClassName, ...rest }, ref) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((v) => !v);
  };

  return (
    <div className={`password-field-with-toggle position-relative w-100 ${wrapperClassName || ''}`.trim()}>
      <InputField
        ref={ref}
        type={passwordVisible ? 'text' : 'password'}
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        maxLength={20}
        className="pe-5"
        {...rest}
      />
      <button
        type="button"
        className="password-field-toggle-icon btn btn-link m-0 p-1 border-0 shadow-none align-middle"
        onClick={togglePasswordVisibility}
        aria-label={passwordVisible ? 'Hide password' : 'Show password'}
      >
        <MDBIcon size="sm" icon={passwordVisible ? 'eye-slash' : 'eye'} />
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
